import styles from './edit-course-dialog.module.scss';
import { useCourseGetRequestHook } from '../../../requestUtils';
import { ICourse } from '../../../_models/course';
import BaseCourseDialog from '../../../base-course-dialog/base-course-dialog';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface EditCourseDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  courseId: string
}

export function EditCourseDialog(props: EditCourseDialogProps) {
  const { data: course }: { data: ICourse } = useCourseGetRequestHook(`course/get/${props.courseId}`, undefined);
  const { t } = useTranslation();

  return course && <BaseCourseDialog
    course={course}
    onClose={props.onClose}
    open={props.open}
    refreshData={props.refreshData}
    handleOkText={t("standard.updateCourse")}
    headerText={t("standard.changeCourse")}
  />
}

export default EditCourseDialog;
